import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Checkmark from '@hellodarwin/icons/dist/icons/Check';
import { useTheme } from 'styled-components';
import Typography from '../../common/typography';
import { LineItemContainer } from './styles';
const PlanTileListItem = ({ children }) => {
    const theme = useTheme();
    return (_jsxs(LineItemContainer, { children: [_jsx("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: 'fit-content',
                    height: theme.fontsLineHeights.body2,
                }, children: _jsx(Checkmark, { size: 16, color: theme.colors.grey_1 }) }), _jsx(Typography, { elementTheme: "body2", children: children })] }));
};
export default PlanTileListItem;
